import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import css from './FavoritePage.css';
import { refreshWishlistListings, removeUnavailableListings } from './FavoritePage.duck';
import { FormattedMessage } from '../../util/reactIntl';
import {
    Page,
    LayoutSingleColumn,
    LayoutWrapperTopbar,
    LayoutWrapperMain,
    LayoutWrapperFooter,
    Footer,
    IconSpinner,
    NoResultsBlock,
    Alert,
    ListingCard,
} from '../../components';
import { TopbarContainer } from '../../containers';
import classNames from 'classnames';

const FavoritePage = () => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const {
        wishlistListings,
        wishlistRequestInProgress,
        wishlistError,
        wishlistListingStatusChanged,
    } = useSelector(state => state['FavoritePage']);

    useEffect(() => {
        /** listings fetched by other pages (e.g. search) are fresher than the cached ones */
        dispatch(refreshWishlistListings());
    }, []);

    const onRemoveUnavailableListings = () => dispatch(removeUnavailableListings());

    const title = intl.formatMessage({ id: 'FavoritePage.title' });
    const noResults = !wishlistListings && !wishlistError && !wishlistRequestInProgress;
    const dataAvailable = wishlistListings && !wishlistError && !wishlistRequestInProgress;

    return (
        <Page className={css.root} title={title}>
            <LayoutWrapperMain blobBackground>
                <LayoutSingleColumn>
                    <LayoutWrapperTopbar>
                        <TopbarContainer currentPage="FavoritePage" />
                    </LayoutWrapperTopbar>
                    <LayoutWrapperMain>
                        <div
                            className={classNames(css.wishlistPanel, {
                                [css.noResultsPanel]: !!noResults,
                            })}
                        >
                            {wishlistRequestInProgress && <IconSpinner />}
                            {noResults && (
                                <NoResultsBlock
                                    headerId="Du hast noch keine Favoriten."
                                    parapraphId="Es scheint so, als hättest Du noch keine Favoriten hinzugefügt."
                                    searchFormPlaceholder="Suche in deiner Nähe"
                                    // rootClass={css.noResults}
                                    isSearchForm
                                />
                            )}
                            {wishlistError && (
                                <Alert
                                    type="failure"
                                    header="FavoritePage.noListingsTitle"
                                    description="FavoritePage.noListingsDesc"
                                />
                            )}
                            {dataAvailable && (
                                <main>
                                    <nav className={css.wishlistsHelmet}>
                                        <h3>
                                            <FormattedMessage id="FavoritePage.heading" />
                                        </h3>
                                        <p>
                                            <FormattedMessage id="FavoritePage.description" />
                                        </p>
                                    </nav>

                                    {wishlistListingStatusChanged && (
                                        <Alert
                                            type="warning"
                                            header="FavoritePage.listingsListChangedTitle"
                                            description="FavoritePage.listingsListChangedDesc"
                                            closeClassName={css.closeAlert}
                                            rootClassName={css.statusChangedPanel}
                                            closeCallback={onRemoveUnavailableListings}
                                        />
                                    )}

                                    <section className={css.wishlistsContainer}>
                                        {wishlistListings.map(listing => (
                                            <ListingCard
                                                className={css.listingCard}
                                                key={listing.id.uuid}
                                                listing={listing}
                                            />
                                        ))}
                                    </section>
                                </main>
                            )}
                        </div>
                    </LayoutWrapperMain>
                    <LayoutWrapperFooter>
                        <Footer />
                    </LayoutWrapperFooter>
                </LayoutSingleColumn>
            </LayoutWrapperMain>
        </Page>
    );
};

export default FavoritePage;
